import { IParams } from '../..';

export const RENT_SUBURBAN_ORDER: (keyof IParams)[] = [
  'bedrooms', // Спален в доме
  'facilities', // Удобства
  'bathType', // Ванна/душ
  'suburbanBathroom', // Санузел
  'repair', // Ремонт
  'area', // Площадь
  'floorsTotal', // Этажей в доме
  'houseYear', // Год постройки
  'houseMaterial', // Тип дома
  'heating', // Тип отопления
  'rentTime', // Срок аренды
  'rentTerms', // Условия сделки
  'livingTerms', // Условия проживания
  'undergroundTime', // До метро
  'publish', // Дата публикации
  'wordsInclude', // Содержит слова в объявлении
  'wordsExclude', // Исключить объявления со словами
  'phone', // Поиск по номеру телефона
  'offerId', // Поиск по номеру объявления
];
